module.exports = __webpack_public_path__ + "static/img/icon-metodologia-2.a5e0247c.svg";